import { IAutoMapper } from "../interfaces";

export const mapRetrievalTimelineItems = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "RetrievalTimelineItem")
    .forMember("specificDay", o => o.specificDay)
    .forMember("timelineGroup", o => o.timelineGroup);
};
